// extracted by mini-css-extract-plugin
module.exports = {"quillDescription":"EpicForm_quillDescription__3qSVD","descriptionField":"EpicForm_descriptionField__3z9QJ","boxFieldSet":"EpicForm_boxFieldSet__3aSyo"};